var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AsrRemoteSelect',_vm._g(_vm._b({attrs:{"placeholder":" "},on:{"change":_vm.onChange},model:{value:(_vm.proxyValue),callback:function ($$v) {_vm.proxyValue=$$v},expression:"proxyValue"}},'AsrRemoteSelect',_vm.proxyProps,false),_vm.proxyEvents))
}
var staticRenderFns = []

export { render, staticRenderFns }